import { Link } from "@tanstack/react-router";
import { ArrowSquareOut } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { EmailTemplatesSection } from "@/components/admin/settings/EmailTemplatesSection";
import { AdminSettingsSectionShell } from "../AdminSettingsSectionShell";

export function CommunicationSection() {
  return (
    <AdminSettingsSectionShell
      title="Komunikacija"
      description="Email template-i se uređuju u settingsu; email logovi ostaju posebna monitoring stranica."
      actions={
        <Button asChild variant="outline" size="sm">
          <Link to="/dashboard/admin/email-logs">
            <ArrowSquareOut className="size-4" />
            Email logovi
          </Link>
        </Button>
      }
    >
      <EmailTemplatesSection />
    </AdminSettingsSectionShell>
  );
}
